import { render, staticRenderFns } from "./alledit.vue?vue&type=template&id=1e01f470&scoped=true&"
import script from "./alledit.vue?vue&type=script&lang=ts&"
export * from "./alledit.vue?vue&type=script&lang=ts&"
import style0 from "./alledit.vue?vue&type=style&index=0&id=1e01f470&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e01f470",
  null
  
)

export default component.exports